export default "__VITE_ASSET__736bc62d__"